// @givmo/app-admin — the "occasion programs aren't on here" state (EP-BE8-web).
//
// The two switches that decide whether this surface exists flip INDEPENDENTLY: the build-time
// `VITE_COMPANY_OCCASION_PROGRAMS_ENABLED` reveals the tab, and the backend
// `COMPANY_OCCASION_PROGRAMS_ENABLED` decides whether its routes answer at all (while off, every one
// of them 404s — the same variable also count-gates the daily Cloud Scheduler job, so a program
// authored against an off backend would never fire).
//
// Gift cards may well go live in an environment where occasion programs are still dark, so that skew is
// an EXPECTED configuration, not a fault. It therefore renders as a considered, calm state — no error
// toast, no red panel, no retry button implying the admin can fix it by trying again.

import { Card, CardBody, Icon, testIdProp } from '@givmo/design-system';
import { CalendarClock } from 'lucide-react';

export interface OccasionUnavailableProps {
  testId?: string;
}

export function OccasionUnavailable({
  testId = 'gift-card-programs-unavailable',
}: OccasionUnavailableProps) {
  return (
    <Card>
      <CardBody className="flex flex-col items-center gap-8 py-32 text-center">
        <Icon icon={CalendarClock} size={24} aria-hidden className="text-text-tertiary" />
        <p
          className="font-sans text-s15 font-w600 tracking-givmo text-text-strong"
          {...testIdProp(testId)}
        >
          Occasion programs aren’t available in this environment yet
        </p>
        <p className="max-w-[420px] font-sans text-s13 leading-h15 tracking-givmo text-text-secondary">
          Standing birthday, work-anniversary and new-hire gifts are still being rolled out. Nothing
          is wrong with your account — you can keep sending gift cards from the other tabs.
        </p>
      </CardBody>
    </Card>
  );
}
